import * as R from 'ramda'

export const useCanSubmitApprovedChewyActiveRx = R.T
